module.exports = __webpack_public_path__ + "static/media/staticImageIcon.97696eea.svg";